import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as profileReducers from '../../../profiles/reducers/profiles';
import * as clientReducers from '../../../clients/reducers/client-details';
import * as clientParentsReducers from '../../../client-parents/reducers/client-parents';
import { ClientProfile } from '../models/client-profile';
import { Profile } from '../../../profiles/models/profile';
import * as profileSelectors from '../../../profiles/selectors/profiles';
import * as ProfileTypes from '../../../profiles/models/profile-types';

export const selectProfileState = createFeatureSelector<profileReducers.State>('profiles');
export const selectClientsState = createFeatureSelector<clientReducers.State>('clientDetails');
export const selectClientParentsState = createFeatureSelector<clientParentsReducers.State>('clientParents');


export const selectClientParents = createSelector(
  [selectClientParentsState],
  (clientParentsState: clientParentsReducers.State) => {
    return clientParentsState.clientParents;
  });

export const selectClientProfiles = createSelector(
  [selectClientsState, profileSelectors.selectAll],
  (clientsState: clientReducers.State, allProfiles: Profile[]) => {
    var clientProfiles: ClientProfile[] = [];
    var clients = clientsState.clients;

    for (let client of clients) {
      var newClientProfile: ClientProfile = new ClientProfile();
      newClientProfile.ref = client.Ref;
      newClientProfile.name = client.Ref + " - " + client.Name;

      var foundProfile = getProfileForClient(allProfiles, client.Ref);
      if (foundProfile != null) {
        newClientProfile.profile = foundProfile;
      }

      clientProfiles.push(newClientProfile);
    }
    return clientProfiles;
  }
);

export const selectClientParentsProfiles = createSelector(
  [selectClientParentsState, profileSelectors.selectAll],
  (clientParentsState: clientParentsReducers.State, allProfiles: Profile[]) => {
    var clientProfiles: ClientProfile[] = [];
    var clientParents = clientParentsState.clientParents;

    for (let clientParent of clientParents) {
      var newClientProfile: ClientProfile = new ClientProfile();
      newClientProfile.ref = clientParent.Id;
      newClientProfile.name = clientParent.Id + " - " + clientParent.Name;

      var foundProfile = getProfileForClientParent(allProfiles, clientParent.Id);
      if (foundProfile != null) {
        newClientProfile.profile = foundProfile;
      }

      clientProfiles.push(newClientProfile);
    }
    return clientProfiles;
  }
);

function getProfileForClient(profiles: Profile[], clientRef: number): Profile {
  for (let profile of profiles) {
    if (profile.clientRefs != undefined) {
      if (profile.clientRefs.includes(clientRef)) {
        return profile;
      }
    }
  }
  return profiles.find(x => x.type === ProfileTypes.Standard);
}

function getProfileForClientParent(profiles: Profile[], clientParentId: number): Profile {
  for (let profile of profiles) {
    if (profile.clientParentIds != undefined) {
      if (profile.clientParentIds.includes(clientParentId)) {
        return profile;
      }
    }
  }
  return profiles.find(x => x.type === ProfileTypes.Standard);
}
